export const countConversationOpened = {
  analysisType: 'count',
  eventCollection: 'conversation.opened',
  key: 'countConversationOpened',
}
